
<template>
  <!--审核物业公司-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>公司资质</h3>
        </div>
        <div class="card-body">
          <a-form-item class="form-item-right long_2" v-for="(item, index) of companyInfo" :required="item.key==='contractTime'" :key="index" :label="item.label">
            <div v-if="item.key === 'businessImgUrl'" @click="showPic(item.value)" class="pic-box">
              <img :src="item.value" alt="">
            </div>

            <div v-if="item.key === 'legalImgUrl'" @click="showPic(item.value)" class="pic-box">
              <img :src="item.value" alt="">
            </div>

            <a-date-picker v-if="item.key === 'contractTime'" v-decorator="['contractTime', contractTime]" :disabled="$route.query.status==='1'" format="YYYY-MM-DD"/>

            <span v-if="['businessImgUrl', 'legalImgUrl', 'contractTime'].every((el) => item.key !== el)" class="ant-form-text">{{item.value}}</span>
          </a-form-item>
        </div>
      </div>
    </a-form>

    <template v-if="isAudit">
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--查看图片的弹窗-->
    <a-modal
      class="img-modal"
      :visible="picVisible"
      @cancel="picVisible=false"
      width="auto"
      v-bind="$store.state.modalDetailConfig"
    >
      <img :src="picUrl" alt="">
    </a-modal>

    <!--审核的弹窗-->
    <a-modal
      title="审核"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      centered
      :maskClosable="false"
      :keyboard="false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
    >
      <a-form :form="modalForm">
        <a-form-item v-if="clickType === '1'" v-bind="$store.state.modal_ItemLayout" label="选择角色">
          <a-select
            v-decorator="['roleId', decoratorOptions.roleId]"
            :filterOption="filterOption"
            mode="multiple"
            showSearch
            allowClear
            placeholder="请选择角色"
          >
            <a-select-option v-for="(item, index) of roleList" :key="index" :value="item.value">
              {{item.label}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-else v-bind="$store.state.modal_ItemLayout" label="拒绝原因">
          <a-textarea v-decorator="['verifyRemark', decoratorOptions.verifyRemark]" :rows="4" placeholder="请输入拒绝原因"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { inputSearch } from 'ant-design-vue-admin-x';
import Moment from 'moment';
export default {
  mixins: [inputSearch],
  name: 'auditCompany',
  data () {
    return {
      routeQuery: '',
      picUrl: '',
      picVisible: false,
      isAudit: false,
      clickType: '',
      visible: false,
      btnLoading: { loading: false },
      roleList: [],
      toolBarList: [
        {text: '通过', handle: () => this.showModal('1'), type: 'primary', loading: true, authDisabled: true, key: 'pass'},
        {text: '拒绝', handle: () => this.showModal('2'), type: 'danger', authDisabled: true, key: 'reject'}
      ],
      baseInfo: [
        {key: 'area', label: '所属城市：', value: ''},
        {key: 'propertyFullName', label: '公司名：', value: ''},
        {key: 'trueName', label: '联系人：', value: ''},
        {key: 'mobilePhone', label: '联系人手机号：', value: ''},
        {key: 'gps', label: 'GPS定位：', value: ''},
        {key: 'propertyAddress', label: '公司地址：', value: ''},
        {key: 'contractNumber', label: '合同编号：', value: ''}
      ],
      companyInfo: [
        {key: 'businessNumber', label: '营业执照号：', value: ''},
        {key: 'legalName', label: '法人代表：', value: ''},
        {key: 'businessAddress', label: '注册地址：', value: ''},
        {key: 'businessImgUrl', label: '营业执照照片：', value: ''},
        {key: 'legalImgUrl', label: '法人持身份证照：', value: ''},
        {key: 'contractTime', label: '合同期限：', value: Moment()}
      ],
      contractTime: {
        rules: [{ required: true, message: '请输入合同期限' }]
      },
      decoratorOptions: {
        roleId: {
          rules: [{ required: true, message: '请选择角色' }]
        },
        verifyRemark: {
          validateTrigger: 'blur',
          rules: [{ required: true, message: '请输入拒绝原因' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created () {
    // 0: 未审核；1: 审核通过；2：拒绝
    this.$route.query.status !== '1' ? this.isAudit = true : this.isAudit = false;
    this.propertyManageSelect();
    if (this.$route.query.id) {
      this.routeQuery = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    /* 查看图片 */
    showPic (url) {
      this.picUrl = url;
      this.picVisible = true;
    },
    /*  物业管理下拉（物业管理模块） */
    propertyManageSelect () {
      this.$get({
        url: '/role/property/treeSelect',
        params: {}
      }).then(({data}) => {
        this.roleList = data;
      });
    },
    /* 打开弹窗 */
    showModal (type) {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.clickType = type;
        this.visible = true;
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return; }
        let time = {...this.form.getFieldsValue(['contractTime'])};
        let formatTime = time.contractTime.format('YYYY-MM-DD HH:mm:ss');
        values.roleId && (values.roleId = values.roleId.join(','));
        values = {verifyStatus: this.clickType, contractTime: formatTime, ...values};
        this.$put({
          url: `/property/check/${this.routeQuery}`,
          params: values,
          btnLoading: this.btnLoading
        }).then((res) => {
          this.$store.commit('setOptData', true);
          this.visible = false;
          this.$message.success(`${res.msg}`);
          this.$router.go(-1);
        });
      });
    },
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/property/${this.routeQuery}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            // el.key === 'area' && (el.value = `${data.provinceName} ${data.cityName} ${data.districtName}`);
            el.key === 'gps' && (el.value = `经度: ${data.mapLng} 纬度: ${data.mapLat}`);
            if (el.key === item) {
              el.value = data[item];
            }
          });
          this.companyInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
        if (data.contractTime) {
          this.form.setFieldsValue({contractTime: Moment(data.contractTime)});
        }
      });
    }
  }
};
</script>
